<template>
  <span class="rating-container">
    <v-icon
      class="star"
      color="primary lighten-1"
      :key="'f'+index"
      v-for="(s, index) in value"
      :style="{'font-size': fontSize}">
      star
    </v-icon>

    <v-icon
      class="star"
      color="gray lighten-1"
      :key="'e'+index"
      v-for="(s, index) in 5-value"
      :style="{'font-size': fontSize}">
      star_border
    </v-icon>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    fontSize: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="stylus" scoped>

.rating-container {
  // display: flex;
  // align-items: center;
}

.star {
  // font-size: 1.2rem;
}

.star--full {
  color: $primary-color;
}

.star--empty {
  color: rgb(128, 128, 128);
}
</style>

